import * as moment from 'moment';

export class LocalDateOnlyFormatValueConverter {
    toView(value: Date) {
        return moment.utc(value).local().format('M/D/YYYY');
    }
}